import React, { useCallback, useState, useEffect } from 'react';
import { NavLink }                                 from 'react-router-dom';

import ReadingTimeIcon from '../../../components/icons/ReadingTimeIcon';
import { useCommon }   from '../../../providers/common';

const TopNews = (props) => {
  const {
          news,
        } = props;

  const { pages } = useCommon();

  const [screenWidth, setScreenWidth] = useState(null);

  const getUrlByType = useCallback((news) => {
    const {
            newsTypeId,
            urlKey,
          } = news;

    const template = newsTypeId === 3 ? 'akcii' : 'news';
    const url      = pages.find(page => page.template === template)?.urlKey;
    return url ? `/${url}/${urlKey}` : '/';
  }, [pages]);

  const handleResize = useCallback(() => {
    setScreenWidth(window.innerWidth);
  }, []);

  const getImageBySize = useCallback((index) => {
    if (screenWidth <= 990) {
      return 'image333x236';
    }
    if (index === 0) {
      return 'image490x290';
    }
    return 'image194x206';
  }, [screenWidth]);

  useEffect(() => {
    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);

  return (
    <div className={'top_news_wrapper'}>
      {news.map((newsItem, index) =>
        (
          <NavLink key={newsItem.newsId} className={'top_news_container'} to={getUrlByType(newsItem)}>
            <picture>
              <source
                srcSet={`${newsItem[getImageBySize(index)] || newsItem.headImage}.webp?default=horizontal&t=${BUILD_TIME}`}
                type={'image/webp'}
              />
              <img
                src={`${newsItem[getImageBySize(index)] || newsItem.headImage}.png?default=horizontal&t=${BUILD_TIME}`}
                alt={newsItem.label}
              />
            </picture>
            <div className={'top_news_description_container'}>
              <div className={'top_news_time_container'}>
                <p className={'top_news_time_date'}>{newsItem.createdAt}</p>
                {newsItem?.readingTime && (
                  <div className={'reading_time_wrapper'}>
                    <ReadingTimeIcon />
                    <p className={'reading_time'}>{newsItem?.readingTime}</p>
                  </div>)}
              </div>
              <h3 className={'top_news_title'}>{newsItem.label}</h3>
              <p className={'top_news_description'}>{newsItem.announce}</p>
              <div className={'top_news_tags'}></div>
            </div>
          </NavLink>),
      )}
    </div>
  );
};

export default TopNews;